export default __webpack_public_path__ + "static/cloudator-full-4-a761ac7f8ac397e86c319d2d3ac219c3.png";